module.exports = __webpack_public_path__ + "img/spin_btn.6f45fa1b.png";